import { Container, Row, Col } from "react-bootstrap";
import { Routes, Route, Navigate } from "react-router-dom";
import "./App.css";
import Login from "./components/Login";
import Signup from "./components/Signup";
import ProtectedRoute from "./components/ProtectedRoute";
import { UserAuthContextProvider } from "./context/UserAuthContext";
import React from "react";
import HubSpotAuth from "./components/HubSpotAuth";
import SlackAuth from "./components/SlackAuth";
import Dashboard from "./components/Dashboard";
import AppLayout from "./components/AppLayout";
import TeamPage from "./components/TeamPage";
import Billing from "./components/Billing";
import AcceptInvite from "./components/AcceptInvite";
import ChatPage from "./components/chat/ChatPage";


function App() {
    return (
        <UserAuthContextProvider>
            <Routes>
                {/* Public routes — centered card layout */}
                <Route path="/" element={
                    <div className="centeredPage">
                        <Login />
                    </div>
                } />
                <Route path="/signup" element={
                    <div className="centeredPage">
                        <Signup />
                    </div>
                } />

                {/* OAuth callbacks — sidebar layout */}
                <Route path="/auth-hubspot" element={
                    <ProtectedRoute>
                        <AppLayout><HubSpotAuth /></AppLayout>
                    </ProtectedRoute>
                } />
                <Route path="/auth-slack" element={
                    <ProtectedRoute>
                        <AppLayout><SlackAuth /></AppLayout>
                    </ProtectedRoute>
                } />

                {/* Authenticated routes — sidebar layout */}
                <Route path="/auth" element={
                    <ProtectedRoute>
                        <AppLayout><Dashboard /></AppLayout>
                    </ProtectedRoute>
                } />

                {/* Chat */}
                <Route path="/chat" element={
                    <ProtectedRoute>
                        <AppLayout fullWidth><ChatPage /></AppLayout>
                    </ProtectedRoute>
                } />

                {/* Team management */}
                <Route path="/team" element={
                    <ProtectedRoute>
                        <AppLayout><TeamPage /></AppLayout>
                    </ProtectedRoute>
                } />

                {/* Billing */}
                <Route path="/billing" element={
                    <ProtectedRoute>
                        <AppLayout><Billing /></AppLayout>
                    </ProtectedRoute>
                } />

                {/* Accept invite (public-ish — just needs auth) */}
                <Route path="/accept-invite" element={
                    <ProtectedRoute>
                        <AcceptInvite />
                    </ProtectedRoute>
                } />

                {/* Backwards-compat redirect */}
                <Route path="/auth-success" element={<Navigate to="/auth" replace />} />
            </Routes>
        </UserAuthContextProvider>
    );
}

export default App;
